import React, { FC } from 'react';

import { FilterStateProvider } from '@/controllers';
import { PageHeader } from '@/components/primitive';
import { Reports } from '@/components/composed';
import { ExperienceErrorBoundary } from '@/components/primitive/error-boundary';
import SearchV2 from '@/components/composed/catalog-search-bar';
import {
  SearchQueryStateProvider,
  queryStore,
} from '@/components/composed/catalog-search-bar/stores/query';
import * as queryUtils from '@/components/composed/catalog-search-bar/services/utils';
import { WithPageTitle } from '@/components/primitive/with-page-title';

import { headerCopy } from './constants';

const DashboardReports: FC = () => {
  const { state: queryState } = React.useContext(queryStore);
  const capabilityAPIQuery = queryUtils.mapParamsToAPIQuery(queryState.params, true);

  return (
    <ExperienceErrorBoundary>
      <div data-testid="dashboard">
        {/* FIXME: Remove when pushing. Also investigate why this is re-rendering 5 times. */}
        {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
        <SearchV2 />
        <Reports query={capabilityAPIQuery} />
      </div>
    </ExperienceErrorBoundary>
  );
};

const MemoisedReports = React.memo(DashboardReports);

const Dashboard: React.FC = () => (
  <WithPageTitle title={headerCopy.title}>
    <SearchQueryStateProvider>
      <FilterStateProvider>
        <PageHeader title={headerCopy.title} description={headerCopy.description} />
        <MemoisedReports />
      </FilterStateProvider>
    </SearchQueryStateProvider>
  </WithPageTitle>
);

export default React.memo(Dashboard);
